import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="empty">
      <h1>Seite nicht gefunden</h1>
      <p>
        <Link to="/">Zurück zur Startseite</Link>
      </p>
    </div>
  )
}
